<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `/transaction/placement/send-placement-result-test/${inputs.id}` : `/transaction/placement/send-placement-result-test`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_analys_type" class="col-sm-3 mb-0">
						Analys Type
					</label>
					<app-input
						id="inputs_analys_type"
						class="col-sm-9"
						type="text"
						v-model="inputs.analys_type"
						placeholder="Analys Type"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_content_test" class="col-sm-3 mb-0">
						Content Test
					</label>
					<app-input
						id="inputs_content_test"
						class="col-sm-9"
						type="text"
						v-model="inputs.content_test"
						placeholder="Content Test"
						required
					/>
				</div>
                <div class="form-group row align-items-center">
					<label for="inputs_material" class="col-sm-3 mb-0">
						Material
					</label>
					<app-input
						id="inputs_material"
						class="col-sm-9"
						type="text"
						v-model="inputs.material"
						placeholder="Material"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_material_test" class="col-sm-3 mb-0">
						Test
					</label>
					<app-input
						id="inputs_material_test"
						class="col-sm-9"
						type="text"
						v-model="inputs.material_test"
						placeholder="Test"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_score" class="col-sm-3 mb-0">
						Score
					</label>
					<app-input
						id="inputs_correct"
						class="col-sm-2"
						type="number"
						v-model="inputs.correct"
						placeholder="78"
						required
					/>
					<app-input
						id="inputs_total_mission"
						class="col-sm-2"
						type="number"
						v-model="inputs.total_mission"
						placeholder="78"
						required
					/>
					<app-input
						id="inputs_score"
						class="col-sm-2"
						type="text"
  						v-model="scoreWithPercent"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_duration" class="col-sm-3 mb-0">
						Duration
					</label>
					
					<app-input
						id="inputs_duration_mm"
						class="col-sm-2 text-center"
						type="text"
						v-model="duration_mm"
						@input="onDurationMM"
						placeholder="00"
						required
					/>
					<app-input
						id="inputs_duration_ss"
						class="col-sm-2 text-center"
						type="text"
						v-model="duration_ss"
						placeholder="00"
						@input="onDurationSS"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_result" class="col-sm-3 mb-0">
						Result
					</label>
					<app-input
						id="inputs_result"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.result"
						placeholder="Result"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_note" class="col-sm-3 mb-0">
						Note
					</label>
					<app-input
						id="inputs_note"
						class="col-sm-9"
						type="text"
						v-model="inputs.note"
						placeholder="Note"
					/>
				</div>
				<!-- <div class="form-group row align-items-center" v-if="photoPreview">
					<div class="col-sm-3"></div>
					<div class="col-sm-9">
						<img
							:src="photoPreview"
							alt="Preview"
							style="max-width: 200px; border-radius: 8px;"
						/>
					</div>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_photo" class="col-sm-3 mb-0"> Photo </label>
					<app-input
						type="file"
						class="col-sm-9"
						accept="image/jpeg,image/png"
						:label="'Upload Photo'"
						v-model="inputs.photo"
						@input="handlePhotoChange"
					/>
				</div> -->
				<div class="form-group row align-items-center">
					<div class="col-sm-3 mb-0">
						<br>
					</div>
				</div>
				<div class="form-group row align-items-center">
					<div class="col-sm-3 mb-0">
						<br>
					</div>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "PlacementResultTestTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		placementId: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			preloader: false,
			photoPreview: null,
			duration_mm:'00',
			duration_ss:'00',
			inputs: {
				placement_id: this.placementId,
				analys_type:null,
				content_test:null,
				material:null,
				material_test:null,
				correct:null,
				total_mission:null,
				score:null,
				duration:null,
				// result:null,
				note:null,
				photo:null
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
			
		onDurationMM(val) {
			let clean = this.onlyNumber(val);

			if (clean === '') {
				this.duration_mm = '';
				return;
			}

			if (clean.length > 3) clean = clean.slice(0, 3);

			const num = Number(clean);

			this.duration_mm = num < 10 ? `0${num}` : String(num);
		},

		onDurationSS(val) {
			let clean = (val || '').replace(/\D/g, '');

			if (!clean) {
				this.duration_ss = '';
				return;
			}

			let num = Number(clean);

			if (num > 59) num = 59;

			this.duration_ss = num < 10 ? String(num).padStart(2, '0') : String(num);
		},

		onlyNumber(val) {
			return (val || '').replace(/\D/g, '');
		},
		handlePhotoChange(file) {
			const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

			if (file && !allowedTypes.includes(file.type)) {
				this.$toastr.e('Files must be JPG, PNG or JPEG');
				this.inputs.photo = null;
				this.photoPreview = null;
				return;
			}
        	// this.inputs.photo = file;

			this.photoPreview = URL.createObjectURL(file);
		},
		updateScore() {
			this.inputs.score = this.score;
		},
		submit() {
			
			const formData = new FormData();

			const mm = (this.duration_mm || '00').toString().padStart(2, '0');
			const ss = (this.duration_ss || '00').toString().padStart(2, '0');

			this.inputs.duration = `${mm}:${ss}`;

			for (const key in this.inputs) {
				if (this.inputs[key] !== null && this.inputs[key] !== undefined) {
					if (key === 'photo' && this.inputs.photo instanceof File) {
						formData.append(key, this.inputs.photo);
					} else {
						formData.append(key, this.inputs[key]);
					}
				}
			}

			this.preloader = true;

			axios.post(
				this.$refs.form.dataset.url,
				formData,
				{ headers: { 'Content-Type': 'multipart/form-data' } }
			)
			.then(res => {
				this.afterSuccess(res);
			})
			.catch(err => {
				this.$toastr.e(err.response?.data?.message || err.message);
			})
			.finally(() => {
				this.preloader = false;
			});
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
			this.closeModal(); 
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			if (this.inputs.duration) {
				const parts = this.inputs.duration.split(':');

				this.duration_mm = parts[0] || '00';
				this.duration_ss = parts[1] || '00';
			} else {
				this.duration_mm = '';
				this.duration_ss = '';
			}
			if (this.inputs.photo) {
			this.photoPreview = window.location.origin + this.inputs.photo.replace(/\/+/g, '/');
			} else {
				this.photoPreview = null;
			}
			this.preloader = false;
		},
	},
	computed: {
		scoreWithPercent: {
			get() {
	
			if (this.inputs.score === null || this.inputs.score === undefined) return ''
				return this.inputs.score + '%'
			},
			set(value) {
	
			const numeric = parseInt(value.replace('%','')) || 0
				this.inputs.score = numeric
			}
		},
		score() {
			const correct = Number(this.inputs.correct) || 0
			const total = Number(this.inputs.total_mission) || 0
			if (!total) return 0
			return Math.round((correct / total) * 100)
		}
	},
	watch: {
		'inputs.correct': 'updateScore',
		'inputs.total_mission': 'updateScore'
	},
};
</script>
